export default "__VITE_ASSET__04bdc2c5__"